const drawerSectionId = document.querySelector('cart-drawer').dataset.id;
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      window.dispatchEvent(new CustomEvent('abra:render'));
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: drawerSectionId,
        selector: 'cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: drawerSectionId,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function refreshCartDrawerForAbra() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || cartDrawer.dataset.abraRefreshing === 'true') return;

  const sectionId = cartDrawer.dataset.id;
  if (!sectionId || typeof routes === 'undefined') return;

  cartDrawer.dataset.abraRefreshing = 'true';
  const root = window.Shopify?.routes?.root || '/';
  Promise.all([
    fetch(`${routes.cart_url}?section_id=${sectionId}`).then((response) => response.text()),
    fetch(`${root}?section_id=header`)
      .then((response) => (response.ok ? response.text() : ''))
      .catch(() => ''),
  ])
    .then(([drawerHtml, headerHtml]) => {
      const html = new DOMParser().parseFromString(drawerHtml, 'text/html');
      const sourceDrawer = html.querySelector('cart-drawer');
      const targetInner = cartDrawer.querySelector('.drawer__inner');
      const sourceInner = sourceDrawer?.querySelector('.drawer__inner');
      if (!targetInner || !sourceInner) return;

      const wasOpen = cartDrawer.classList.contains('active');
      targetInner.innerHTML = sourceInner.innerHTML;
      cartDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));

      if (headerHtml) {
        const headerDocument = new DOMParser().parseFromString(headerHtml, 'text/html');
        const sourceIcon = headerDocument.getElementById('cart-icon-bubble');
        const targetIcon = document.getElementById('cart-icon-bubble');
        if (sourceIcon && targetIcon) targetIcon.innerHTML = sourceIcon.innerHTML;
      }

      if (wasOpen) {
        cartDrawer.classList.add('animate', 'active');
        const containerToTrapFocusOn = cartDrawer.classList.contains('is-empty')
          ? cartDrawer.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = cartDrawer.querySelector('.drawer__inner') || cartDrawer.querySelector('.drawer__close');
        if (containerToTrapFocusOn && focusElement && typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      }
      window.dispatchEvent(new CustomEvent('abra:render'));
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      delete cartDrawer.dataset.abraRefreshing;
    });
}

window.addEventListener('abra:cart:changed', refreshCartDrawerForAbra);
